// ----------------------------------------------------------------------- imports externos
import { useEffect, useState } from "react";

// ----------------------------------------------------------------------- imports internos
import { dondeEstaElChofer } from "../../services/porteria";
import { dondeEsta } from "../../shared/chofer";
import { diaAr } from "../../shared/fechaAr";
import { useAvisarVacio } from "./BloqueFicha";

/* «¿Dónde está tal chofer?», en la ficha de la persona.
 *
 * Es la pregunta que llega por teléfono y que hoy se contesta llamando al
 * chofer. La cadena es chofer → interno → posición, y cada eslabón es más
 * flojo que el anterior — por eso la regla de qué se puede afirmar vive en
 * `shared/chofer.js`, aparte y probada en una tabla.
 *
 * EL INTERNO ES EL DATO QUE MÁS SIRVE, incluso cuando no hay lugar. Con el
 * número de la unidad se la busca en el mapa en vivo, que es donde está la
 * posición de verdad — el hub no tiene GPS y no lo va a tener.
 *
 * NO FRENA NADA. Va en su propio estado y si falla no se dibuja: la ficha de
 * una persona tiene que abrir aunque portería no conteste.
 */
const DondeEsta = ({ dni }) => {
  const [fila, setFila] = useState(undefined); // undefined = todavía no llegó
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    let vigente = true;
    setFallo(false);
    dondeEstaElChofer(dni)
      .then((r) => vigente && setFila(r))
      .catch(() => {
        if (!vigente) return;
        setFallo(true);
        setFila(null);
      });
    return () => {
      vigente = false;
    };
  }, [dni]);

  /* En la ficha de la persona, «nunca cruzó el portón» esconde el bloque
   * (Igna, 02/10: lo vacío no aparece). Lo que NO lo esconde es que portería
   * no haya contestado: eso no es un vacío, es no saber. Afuera de esa ficha
   * el aviso no hace nada y esto se dibuja como siempre. */
  useAvisarVacio(
    fila === undefined ? undefined : !fallo && dondeEsta(fila).vacio,
  );

  /* Mientras carga NO se dibuja el bloque vacío: aparecer y cambiar de texto
   * a los 200 ms se lee como que la pantalla se corrigió sola. */
  if (fila === undefined) return null;

  const u = dondeEsta(fila);

  return (
    <div className={"chofer-donde" + (u.vacio ? " chofer-donde--vacia" : "")}>
      <span className="et">Dónde se lo vio</span>
      <span className="chofer-donde-txt" title={u.detalle}>
        <b>{u.titulo}</b>
        {u.lugar && (
          <>
            {" · "}
            <b>{u.lugar}</b>
          </>
        )}
        {fila?.fecha && (
          <span className="chofer-donde-fecha">
            {" "}
            {diaAr(fila.fecha)}
          </span>
        )}
      </span>
      {u.detalle && <span className="chofer-donde-nota">{u.detalle}</span>}
    </div>
  );
};

export default DondeEsta;
